// Credit: https://gist.github.com/TheGreatRambler/048f4b38ca561e6566e0e0f6e71b7739

/**
 * Compute a unique number from two numbers.
 * Supports signed integers.
 */
export function pairingFunction(a: number, b: number) {
  const A = a >= 0 ? 2 * a : -2 * a - 1;
  const B = b >= 0 ? 2 * b : -2 * b - 1;
  return A >= B ? A * A + A + B : B * B + A;
}

/**
 * The reverse of pairingFunction.
 *
 * Computes the two numbers that were used to generate the given number `z`
 */
export function reversePairingFunction(n: number): [number, number] {
  const sqrtn = Math.floor(Math.sqrt(n));
  const sqn = sqrtn * sqrtn;
  const result1: [number, number] =
    n - sqn >= sqrtn ? [sqrtn, n - sqn - sqrtn] : [n - sqn, sqrtn];
  const xx = result1[0] % 2 === 0 ? result1[0] / 2 : (result1[0] + 1) / -2;
  const yy = result1[1] % 2 === 0 ? result1[1] / 2 : (result1[1] + 1) / -2;
  return [xx, yy];
}

// OG code below, might be more space efficient? but produces floats :/

// Credit: https://stackoverflow.com/a/13871379 Szudzik pairing function
// export function pairingFunctionV2(a: number, b: number): number {
//   const A = a >= 0 ? 2 * a : -2 * a - 1;
//   const B = b >= 0 ? 2 * b : -2 * b - 1;
//   const C = (A >= B ? A * A + A + B : A + B * B) / 2;
//   return (a < 0 && b < 0) || (a >= 0 && b >= 0) ? C : -C - 1;
// }
